import {
  GetDeliveryAreaSectionAssignedCountQuery,
  GetDeliveryAreaSectionAssignedCountDocument,
  DeliveryAreaSectionCountInput,
} from "@/generated/graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * 登録されている配達区画件数を取得する
 * @param countInput DeliveryAreaSectionCountInput
 * @returns 登録されている配達区画件数
 */
export async function countDeliverySection(
  countInput: DeliveryAreaSectionCountInput
): Promise<number> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const areaCount: ApolloQueryResult<GetDeliveryAreaSectionAssignedCountQuery> =
      await apolloClient.query<GetDeliveryAreaSectionAssignedCountQuery>({
        query: GetDeliveryAreaSectionAssignedCountDocument,
        variables: {
          countInput: countInput,
        },
        fetchPolicy: "no-cache",
      });
    return areaCount.data.getDeliveryAreaSectionAssignedCount
      ? areaCount.data.getDeliveryAreaSectionAssignedCount.count
      : 0;
  } catch (err: unknown) {
    console.error(err);
    if (err instanceof Error) {
      err.message = "配達区画件数の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("配達区画件数の取得に失敗しました。（Unknown error）");
    }
  }
}
